import React from 'react';

import classNames from 'classnames';

type Props = {
  addBottomBuffer?: string;
  className?: string;
  inline?: boolean;
  loadingText?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  skipTopBuffer?: boolean;
};

export default function LoadingSpinner({
  addBottomBuffer,
  className,
  inline,
  loadingText,
  size = 'xl',
  skipTopBuffer,
}: Props) {
  const spinnerClassNames = classNames(className, {
    'd-inline': inline,
    'text-center': true,
    'mt-5': !skipTopBuffer,
    'mb-5': addBottomBuffer
  });

  return (
    <div className={spinnerClassNames}>
      <div
        className={classNames(
          'spinner-border',
          size !== 'md' && `spinner-${size}`
        )}
        role="status"
      />
      {loadingText && <div className="mt-2 text-muted">{loadingText}</div>}
    </div>
  );
}
